export default __webpack_public_path__ + "static/media/Liliya.574543b9.png";